export default {
  isConversionsEnabled: false,
  requestConversionStatus: { loading: undefined, success: undefined },
  streams: {
    list: {
      /*
        [id] : {
          title: string,
          id: number,
         ...otherProps
        }
      */
    },
    loading: true,
    isLastPage: false,
  },
};
